<template>
  <div>
    <Reassign :headers="headers" 
    :searchUrl="expenseChangeList.todoWorks" 
    :transferUrl="expenseChangeList.todoWorksPassTo" 
    itemValue="formId"
    />
  </div>
</template>

<script setup lang="ts">
import Reassign from './reassign/reassign.vue';
import { expenseChangeList } from './api/ExpenseChangeList/ExpenseChangeListApi';

definePage({
  meta: {
    action: 'manage',
    subject: 'EXPENSECHANGEREASSIGN',
  },
})

const headers = [
  { title: '經費變更單號', key: 'changeNo', sortable: true },
  { title: '申請人', key: 'applyEmpNo', sortable: true },
  { title: '申請時間', key: 'applyTime', sortable: true },
];

</script>

<style>

</style>